import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'styled-components'
import { DndProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'

import App from './App'
import registerServiceWorker from './registerServiceWorker'
import theme from 'config/theme'

import 'style/index.scss'
import './i18n/init'

// window.LOG_LEVEL = 'DEBUG'

const Index = () => {
	return(
		<ThemeProvider theme={theme}>
			<DndProvider backend={HTML5Backend} options={{ enableMouseEvents: true }}>
				<App/>
			</DndProvider>
		</ThemeProvider>
	)
}

ReactDOM.render(
	<Index />,
	document.getElementById('root')
)

registerServiceWorker()
